import { $Formutil } from 'react-bootstrap-formutil';

// 豁免证明类型枚举
export enum PicExemptionEnum {
    /** 其他券商证明 */
    OTHER_BROKER_PROOF = 'other_broker_proof'
}

export interface UploadExemptionFieldType {
    pic_exemption_type: PicExemptionEnum;
    pic_exemption: string;
}

export interface UploadExemptionProps {
    $formutil: $Formutil<UploadExemptionFieldType>;
    // 从customerInfo中获取的类型，如果有值不允许修改
    customerExemptionType?: PicExemptionEnum;
}
